// src/components/RuleListItem.tsx
import React from 'react';
import { Paper, Typography, Stack, IconButton, Chip } from '@mui/material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { Rule } from './CampaignEditorPage'; // Asegúrate que la ruta de importación sea correcta

interface RuleListItemProps {
  rule: Rule;
  isSelected: boolean;
  onClick: () => void;
  dragHandleProps: any;
}

const RuleListItem: React.FC<RuleListItemProps> = ({ rule, isSelected, onClick, dragHandleProps }) => {
  return (
    <Paper
      elevation={isSelected ? 4 : 1}
      onClick={onClick}
      sx={{
        p: 2,
        cursor: 'pointer',
        border: isSelected ? '2px solid' : '2px solid transparent',
        borderColor: isSelected ? 'primary.main' : 'transparent',
        transition: 'border-color 0.2s, box-shadow 0.2s',
        '&:hover': {
          borderColor: 'primary.light',
        },
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        <Stack {...dragHandleProps} sx={{ cursor: 'grab' }}>
          <DragIndicatorIcon color="action" />
        </Stack>
        <Typography variant="body1" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
          {rule.name}
        </Typography>
        <Chip
          label={rule.status === 'active' ? 'Activa' : 'Inactiva'}
          color={rule.status === 'active' ? 'success' : 'default'}
          size="small"
        />
      </Stack>
    </Paper>
  );
};

export default RuleListItem;